<template>
  <div>
    <v-header />
    <div id="magazine">
      <div class="page1">
        <img src="./pages/finger.gif" />
        <!-- <img src="./pages/0001.jpg" /> -->
      </div>
      <div>
        <img src="./pages/0002.jpg" />
      </div>
      <div>
        <img src="./pages/0003.jpg" />
      </div>
      <div>
        <img src="./pages/0004.jpg" />
      </div>
      <div>
        <img src="./pages/0005.jpg" />
      </div>
      <div>
        <img src="./pages/0006.jpg" />
      </div>
      <div>
        <img src="./pages/0007.jpg" />
      </div>
      <div>
        <img src="./pages/0008.jpg" />
      </div>
      <div>
        <img src="./pages/0009.jpg" />
      </div>
      <div>
        <img src="./pages/0010.jpg" />
      </div>
      <div>
        <img src="./pages/0011.jpg" />
      </div>
      <div>
        <img src="./pages/0012.jpg" />
      </div>
      <div>
        <img src="./pages/0013.jpg" />
      </div>
      <div>
        <img src="./pages/0014.jpg" />
      </div>
      <div>
        <img src="./pages/0015.jpg" />
      </div>
      <div>
        <img src="./pages/0016.jpg" />
      </div>
      <div>
        <img src="./pages/0017.jpg" />
      </div>
      <div>
        <img src="./pages/0018.jpg" />
      </div>
      <div>
        <img src="./pages/0019.jpg" />
      </div>
      <div>
        <img src="./pages/0020.jpg" />
      </div>
      <div>
        <img src="./pages/0021.jpg" />
      </div>
      <div>
        <img src="./pages/0022.jpg" />
      </div>
      <div>
        <img src="./pages/0023.jpg" />
      </div>
      <div>
        <img src="./pages/0024.jpg" />
      </div>
      <div>
        <img src="./pages/0025.jpg" />
      </div>
      <div>
        <img src="./pages/0026.jpg" />
      </div>
      <div>
        <img src="./pages/0027.jpg" />
      </div>
      <div>
        <img src="./pages/0028.jpg" />
      </div>
      <div>
        <img src="./pages/0029.jpg" />
      </div>
      <div>
        <img src="./pages/0030.jpg" />
      </div>
    </div>
    <v-footer />
  </div>
</template>
<script>
import Header from '../home/components/header.vue';
import Footer from '../home/components/footer.vue';
// import $ from 'jquery';
import './turn';

// $(window).bind('keydown', function(e) {
//   if (e.keyCode == 37) $('#magazine').turn('previous');
//   else if (e.keyCode == 39) $('#magazine').turn('next');
// });
export default {
  mounted() {
    this.$nextTick(() => {
      $('#magazine').turn({
        display: 'double',
        acceleration: true,
        gradients: !$.isTouch,
        elevation: 50,
        when: {
          turned: function(e, page) {
            /*console.log('Current view: ', $(this).turn('view'));*/
          },
        },
      });
    });
  },
  components: {
    'v-header': Header,
    'v-footer': Footer,
  },
};
</script>
<style lang="less">
#magazine {
  width: 1152px;
  height: 752px;
  margin: 30px auto 50px;
  .page1 {
    background-image: url(./pages/0001.jpg);
    background-size: 100% 100%;
    > img {
      width: 70px;
      height: 70px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
